module.exports = __webpack_public_path__ + "img/banner2_i.0aef9d3f.png";